// Zero is neutral. Never green for $0.00.
export function pnlColorClass(value: number | null | undefined): string {
  if (value === null || value === undefined) return 'text-gray-400';
  if (value > 0) return 'text-green-400';
  if (value < 0) return 'text-red-400';
  return 'text-gray-400';
}
